import {
  FETCH_LANGUAGES_REQUEST,
  FETCH_LANGUAGES_SUCCESS,
  FETCH_LANGUAGES_FAILURE,
  SAVE_LANGUAGE_REQUEST,
  SAVE_LANGUAGE_SUCCESS,
  SAVE_LANGUAGE_FAILURE,
  DELETE_LANGUAGE_REQUEST,
  DELETE_LANGUAGE_SUCCESS,
  DELETE_LANGUAGE_FAILURE,
  FETCH_ISO_LANGUAGES_REQUEST,
  FETCH_ISO_LANGUAGES_SUCCESS,
  FETCH_ISO_LANGUAGES_FAILURE,
  CLEAR_LANGUAGE_ERRORS,
} from './types';

const INITIAL_STATE = {
  isoLanguageList: [],
  languageList: [],
  loading: false,
  error: null,
  errorData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ISO_LANGUAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        errorData: null,
      };
    case FETCH_ISO_LANGUAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        isoLanguageList: action.payload,
      };

    case FETCH_ISO_LANGUAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        isoLanguageList: [],
      };
    case FETCH_LANGUAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        errorData: null,
      };
    case FETCH_LANGUAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        languageList: action.payload,
      };

    case FETCH_LANGUAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        languageList: [],
      };
    case SAVE_LANGUAGE_REQUEST:
      return {
        ...state,
        error: null,
        errorData: null,
      };

    case SAVE_LANGUAGE_SUCCESS:
      return {
        ...state,
      };

    case SAVE_LANGUAGE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        errorData: action.payload.poiList,
      };

    case DELETE_LANGUAGE_REQUEST:
      return {
        ...state,
        error: null,
        errorData: null,
      };

    case DELETE_LANGUAGE_SUCCESS:
      return {
        ...state,
      };

    case DELETE_LANGUAGE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case CLEAR_LANGUAGE_ERRORS:
      return {
        ...state,
        error: null,
        errorData: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
